import Donation from 'entities/donation/model';

import {
  ADD,
  ADD_MULTIPLE,
  SET_DISPLAYED_DONATION_IDS,
  SET_DONATIONS_LOADED,
  SET_TOTAL,
  UPDATE_MULTIPLE,
  UPDATE_DONATION_DESIRED_AMOUNT,
  SET_PENDING_EXTERNAL_TOTAL,
} from './constants';

export type AddMultipleAction = {
  type: typeof ADD_MULTIPLE;
  donations: Donation[];
};
export const addMultipleAction = (donations: Donation[]): AddMultipleAction => ({
  type: ADD_MULTIPLE,
  donations,
});

export type UpdateMultipleAction = {
  type: typeof UPDATE_MULTIPLE;
  donations: Donation[];
};
export const updateMultipleAction = (donations: Donation[]): UpdateMultipleAction => ({
  type: UPDATE_MULTIPLE,
  donations,
});

export type SetTotalsAction = {
  type: typeof SET_TOTAL;
  total: number;
};
export const setTotalAction = (total: number): SetTotalsAction => ({
  type: SET_TOTAL,
  total,
});

export type SetPendingExternalTotalAction = {
  type: typeof SET_PENDING_EXTERNAL_TOTAL;
  total: number;
};
export const setPendingExternalTotalAction = (total: number): SetPendingExternalTotalAction => ({
  type: SET_PENDING_EXTERNAL_TOTAL,
  total,
});

export type SetDisplayedDonationIdsAction = {
  type: typeof SET_DISPLAYED_DONATION_IDS;
  donationIds: string[];
};
export const setDisplayedDonationIdsAction = (
  donationIds: string[]
): SetDisplayedDonationIdsAction => ({
  type: SET_DISPLAYED_DONATION_IDS,
  donationIds,
});

export type AddAction = {
  type: typeof ADD;
  donation: Donation;
};
export const addAction = (donation: Donation): AddAction => ({
  type: ADD,
  donation,
});

export type SetDonationsLoadedAction = {
  type: typeof SET_DONATIONS_LOADED;
  userId: string;
};
export const setDonationsLoaded = (userId: string): SetDonationsLoadedAction => ({
  type: SET_DONATIONS_LOADED,
  userId,
});

export type UpdateDonationDesiredAmountAction = {
  type: typeof UPDATE_DONATION_DESIRED_AMOUNT;
  donationId: string;
  desiredMatchAmount: number;
  desiredMatchingRule?: string;
};

export const updateDonationDesiredAmountAction = (
  donationId: string,
  desiredMatchAmount: number,
  desiredMatchingRule?: string
): UpdateDonationDesiredAmountAction => ({
  type: UPDATE_DONATION_DESIRED_AMOUNT,
  donationId,
  desiredMatchAmount,
  desiredMatchingRule,
});
export type DonationActions =
  | AddMultipleAction
  | UpdateMultipleAction
  | SetTotalsAction
  | SetDisplayedDonationIdsAction
  | AddAction
  | SetDonationsLoadedAction
  | SetPendingExternalTotalAction
  | UpdateDonationDesiredAmountAction;
